import React, { Fragment } from 'react'
import Gauge from '../../../../components/MacrosGauge'
import MiniGauge from '../../../../components/Gauge'
import './Nutrition.css'

import Modal from 'react-modal'
import Close from '../../../../assets/img/close-outline.png'
import Button from '../../../../components/Button'

const MACRO_FAT = 9
const MACRO_CARBS = 4
const MACRO_PROTEIN = 4

const getCalories = (grams, k) => Number(grams) * Number(k)

const getPercentage = (calories, totalCalories) =>
  Math.floor((Number(calories) * 100) / Number(totalCalories))

const FAT = 65
const CARBS = 278
const PROTEIN = 50

const getDietaryValue = (grams, k) => (Number(grams) / Number(k)) * 100

const roundTo100 = arr => {
  const { indexOfHighest, remaining } = arr.reduce(
    ({ indexOfHighest, remaining, highest }, curr, i) => {
      let newHighest = highest
      let newIndex = indexOfHighest
      const newRemaining = remaining - curr

      if (curr > highest) {
        newHighest = curr
        newIndex = i
      }

      return {
        indexOfHighest: newIndex,
        highest: newHighest,
        remaining: newRemaining
      }
    },
    { indexOfHighest: 0, remaining: 100, highest: 0 }
  )

  return arr.map((n, i) => {
    if (i === indexOfHighest) {
      return n + remaining
    }

    return n
  })
}

class NutritionInfo extends React.Component {
  state = {
    showNutritionModal: false
  }

  toggleNutritionModal = () => {
    this.setState(prevState => ({
      showNutritionModal: !prevState.showNutritionModal
    }))
  }

  render() {
    const { mealDetail } = this.props
    const { showNutritionModal } = this.state

    if (!mealDetail || !mealDetail.nutritionInfo) return null

    const { nutritionInfo } = mealDetail

    const dailyValue = Math.floor((nutritionInfo.calories * 100) / 2000)

    const proteinCal = getCalories(nutritionInfo.protein, MACRO_PROTEIN)

    const carbsCal = getCalories(nutritionInfo.carbs, MACRO_CARBS)

    const fatCal = getCalories(nutritionInfo.fat, MACRO_FAT)

    const calculatedCal = proteinCal + carbsCal + fatCal

    let protein = getPercentage(proteinCal, calculatedCal)
    let carbs = getPercentage(carbsCal, calculatedCal)
    let fat = getPercentage(fatCal, calculatedCal)

    ;[protein, carbs, fat] = roundTo100([protein, carbs, fat])

    const calories = nutritionInfo.calories

    return (
      <Fragment>
        <Modal
          className="modal-reviews"
          overlayClassName="modal-reviews-overlay"
          isOpen={showNutritionModal}
          onRequestClose={() => this.toggleNutritionModal()}>
          <div className="header-modal">
            <h2 className="title-section">Nutritional Value</h2>
            <img
              alt="close"
              src={Close}
              onClick={() => this.toggleNutritionModal()}
            />
          </div>
          <div>
            <div className="tabs-col-container">
              <span className="tab-info">Serving Size</span>
              <span>{nutritionInfo.servingSize}g</span>
            </div>
            <div className="tabs-col-container">
              <span className="tab-info">Energy</span>
              <span>{nutritionInfo.calories}cal</span>
            </div>
            <div className="tabs-col-container">
              <span className="tab-info">Fat</span>
              <span>{nutritionInfo.fat}g</span>
            </div>
            <div className="tabs-col-container">
              <span className="tab-info">of which saturated fat</span>
              <span>{nutritionInfo.saturatedFat}g</span>
            </div>
            <div className="tabs-col-container">
              <span className="tab-info">Carbs</span>
              <span>{nutritionInfo.carbs}g</span>
            </div>
            <div className="tabs-col-container">
              <span className="tab-info">of which sugars</span>
              <span>{nutritionInfo.sugar}g</span>
            </div>
            <div className="tabs-col-container">
              <span className="tab-info">Proteins</span>
              <span>{nutritionInfo.protein}g</span>
            </div>
            <div className="tabs-col-container">
              <span className="tab-info">Fiber</span>
              <span>{nutritionInfo.fiber}g</span>
            </div>
            <div className="tabs-col-container">
              <span className="tab-info">Sodium</span>
              <span>{nutritionInfo.sodium}mg</span>
            </div>
          </div>
        </Modal>
        <div className="nutrition">
          {!!nutritionInfo.calories && (
            <div className="macronutrients_container">
              <div className="macronutrients_gauge">
                <p className="title">Macronutrients</p>
                <p className="subtitle">
                  Estimated total calories contained on this meal
                </p>

                <Gauge
                  protein={protein}
                  carbs={carbs}
                  fat={fat}
                  calories={calories}
                  dv={dailyValue}
                />
              </div>
              <div className="macronutrients_details">
                <div className="detail_item size">
                  <div className="info">
                    <p className="label">Energy</p>
                    <p className="value">{nutritionInfo.calories}cal</p>
                  </div>
                  <MiniGauge progress={dailyValue} unit="dv" />
                </div>

                <div className="detail_item fat">
                  <div className="info">
                    <p className="label">Fat</p>
                    <p className="value">{nutritionInfo.fat}g</p>
                  </div>
                  <MiniGauge
                    progress={getDietaryValue(nutritionInfo.fat, FAT)}
                    unit="dv"
                  />
                </div>

                <div className="detail_item carbs">
                  <div className="info">
                    <p className="label">Carbs</p>
                    <p className="value">{nutritionInfo.carbs}g</p>
                  </div>
                  <MiniGauge
                    progress={getDietaryValue(nutritionInfo.carbs, CARBS)}
                    unit="dv"
                  />
                </div>

                <div className="detail_item proteins">
                  <div className="info">
                    <p className="label">Proteins</p>
                    <p className="value">{nutritionInfo.protein}g</p>
                  </div>
                  <MiniGauge
                    progress={getDietaryValue(nutritionInfo.protein, PROTEIN)}
                    unit="dv"
                  />
                </div>

                <div className="details_table">
                  <div className="table_row">
                    <p className="label">Saturated Fat</p>
                    <p className="value">{nutritionInfo.saturatedFat}g</p>
                  </div>

                  <div className="table_row">
                    <p className="label">Fiber</p>
                    <p className="value">{nutritionInfo.fiber}g</p>
                  </div>

                  <div className="table_row">
                    <p className="label">Sodium</p>
                    <p className="value">{nutritionInfo.sodium}mg</p>
                  </div>

                  <div className="table_row">
                    <p className="label">Sugar</p>
                    <p className="value">{nutritionInfo.sugar}g</p>
                  </div>
                </div>
              </div>
            </div>
          )}

          {!!nutritionInfo.calories && (
            <Button onClick={() => this.toggleNutritionModal()}>
              View all nutrition facts
            </Button>
          )}
        </div>
      </Fragment>
    )
  }
}

export default NutritionInfo



// WEBPACK FOOTER //
// ./src/modules/MealDetail/components/Nutrition/index.js